import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../services/feedback.service';
import { Globals } from '../globals';
declare var $, unescape, escape: any;

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
	UserList;

	constructor(public globals: Globals, private FeedbackService: FeedbackService, ) { }

	ngOnInit() {
		var currentYear = (new Date()).getFullYear();
		$("#footer_year").html(currentYear);
		checkCookie_eu();

		function checkCookie_eu() {

			var consent = getCookie_eu("cookies_consent");

			if (consent == null || consent == "" || consent == undefined) {
				// show notification bar
				$('#cookie_directive_container').show();
			}

		}

		function setCookie_eu(c_name, value, exdays) {

			var exdate = new Date();
			exdate.setDate(exdate.getDate() + exdays);
			var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
			document.cookie = c_name + "=" + c_value + "; path=/";

			$('#cookie_directive_container').hide();
		}


		function getCookie_eu(c_name) {
			var i, x, y, ARRcookies = document.cookie.split(";");
			for (i = 0; i < ARRcookies.length; i++) {
				x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
				y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
				x = x.replace(/^\s+|\s+$/g, "");
				if (x == c_name) {
					return unescape(y);
				}
			}
		}
		this.globals.isLoading = true;
		this.FeedbackService.getUserList()
			.then((data) => {
				//let todaysdate = this.globals.todaysdate;
				var d = new Date();

				var month = d.getMonth() + 1;
				var day = d.getDate();

				var output = month + '-' + day + '-' + d.getFullYear();



				setTimeout(function () {
					var table = $('#list_tables').DataTable({
						//  scrollY: '55vh',
						responsive: {
							details: {
								display: $.fn.dataTable.Responsive.display.childRowImmediate,
								type: ''
							}
						},
						scrollCollapse: true,
						"oLanguage": {
							"sLengthMenu": "_MENU_ Users per page",
							"sInfo": "Showing _START_ to _END_ of _TOTAL_ Users",
							"sInfoFiltered": "(filtered from _MAX_ total Users)",
							"sInfoEmpty": "Showing 0 to 0 of 0 Users"
						},
						dom: 'lBfrtip',
						buttons: [

						]
					});

					var buttons = new $.fn.dataTable.Buttons(table, {
						buttons: [
							{
								extend: 'excel',
								title: 'LearnFeedback Demo – All Users – ' + output,
								filename: 'LearnFeedbackDemo–AllUsers–' + output,

								customize: function (xlsx) {
									var source = xlsx.xl['workbook.xml'].getElementsByTagName('sheet')[0];
									source.setAttribute('name', 'LFB-AllUsers');
								},
								exportOptions: {
									columns: [0, 1, 2, 3, 4, 5, 6, 7]
								}
							},
							{
								extend: 'print',
								title: 'LearnFeedback Demo – All Users – ' + output,
								exportOptions: {
									columns: [0, 1, 2, 3, 4, 5, 6, 7]
								}
							},
						]
					}).container().appendTo($('#buttons'));

					$('.buttons-excel').attr('data-original-title', 'Export').tooltip();
					$('.buttons-print').attr('data-original-title', 'Print').tooltip();
				}, 100);
				if (data) {
					this.UserList = data;
				}
				this.globals.isLoading = false;
			},
				(error) => {
					this.globals.isLoading = false;
				});
	}
	close_cookie() {
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + 30);
		var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
		document.cookie = "cookies_consent =" + c_value + "; path=/";

		$('#cookie_directive_container').hide();
	}

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/user-list/user-list.component.ts